import { Component, Inject, Prop, Vue } from "vue-property-decorator";
import {
  MEDICAL_ORDER_CONSTANTS,
  MEDICAL_ORDER_VALIDATORS,
  MEDICAL_ORDER_FILE_FORMAT,
  CLOSE_MASIVE_ORDER_MODAL,
  MEDICAL_ORDER_ACCESS
} from "../../constants/MedicalOrderConstants";
import { STYLE_CLASSES } from "@/shared/constants/StyleConstants";
import {
  FORM_MESSAGES,
  FORM_CONSTANTS,
  FORM_VALIDATORS
} from "@/shared/constants/FormConstants";
import ModalTemplate from "@/shared/components/ModalTemplate/ModalTemplate.vue";
import XLSX from "xlsx";
import { MedicalOrderService } from "../../services/MedicalOrderService";
import { OrderService } from "@/modules/Orders/services/OrderService";
import Snackbar from "@/shared/components/Snackbar/Snackbar";
import { Http } from "@status/codes";
import { LoadOrdersError } from "../../models/LoadOrdersError";
import { Utils } from "@/shared/utils/utils";
import { SNACKBAR_STYLE } from "@/shared/constants/StyleConstants";
import { GENERAL_CONSTANTS } from "@/shared/constants/GeneralConstants";
@Component({
  name: "LoadOrders",
  components: {
    ModalTemplate
  }
})
export default class LoadOrders extends Vue {
  @Inject() medicalOrderService!: MedicalOrderService;
  @Inject() orderService!: OrderService;
  @Prop() isOnModal?: boolean;

  TITLE = MEDICAL_ORDER_CONSTANTS.LOAD_ORDERS_TITLE;
  TITLE_VALIDATION_ERRORS = MEDICAL_ORDER_CONSTANTS.TITLE_VALIDATION_ERRORS;
  TITLE_ERRORS = MEDICAL_ORDER_CONSTANTS.TITLE_ERRORS;
  ROWS_OK = MEDICAL_ORDER_CONSTANTS.ROWS_OK;
  ROWS_ERROR = MEDICAL_ORDER_CONSTANTS.ROWS_ERROR;
  LOAD_BUTTON = MEDICAL_ORDER_CONSTANTS.BUTTON.LOAD_BUTTON;
  CANCEL_BUTTON = FORM_CONSTANTS.BUTTON.CANCEL;
  SELECT_FILE = MEDICAL_ORDER_CONSTANTS.LABELS.SELECT_FILE;
  MEDICAL_ORDER_FILE_FORMAT = MEDICAL_ORDER_FILE_FORMAT;
  HINT_FILE = MEDICAL_ORDER_CONSTANTS.LABELS.MAX_SIZE;
  PAGE_START = FORM_CONSTANTS.BUTTON.PAGE_START;
  WARNING_COLOR = SNACKBAR_STYLE.WARNING.COLOR;
  ERROR_COLOR = SNACKBAR_STYLE.ERROR.COLOR;
  SUCCESS_COLOR = SNACKBAR_STYLE.SUCCESS.COLOR;
  SELECT_DOCUMENT_LABEL = MEDICAL_ORDER_CONSTANTS.LABELS.FORMAT_VALID;
  LOADGIN_TEXT = MEDICAL_ORDER_CONSTANTS.LABELS.LOADING;

  cardClass = STYLE_CLASSES.CARD;
  textFieldClass = STYLE_CLASSES.TEXT_FIELD;
  iconBtnClass = STYLE_CLASSES.ICON_BTN;

  rulesFile = [
    FORM_VALIDATORS.REQUIRED_FIELD,
    MEDICAL_ORDER_VALIDATORS.FILE_FORMAT,
    MEDICAL_ORDER_VALIDATORS.MAX_FILE_SIZE
  ];

  loadOrders = false;
  modalTextLoadOrders = "";
  modalTitleLoadOrders = "";
  modalDialogLoadOrders = false;
  medicalOrdersFile: File = new File([], "");
  fileReader = new FileReader();
  errorsLoadOrders: LoadOrdersError[] = [];
  loadingData = false;
  rowsError = 0;
  rowsOk = 0;
  loadFinish = false;
  btnClassPrimaryRound = STYLE_CLASSES.PRIMARY_ROUND_BTN;
  fileLink = MEDICAL_ORDER_CONSTANTS.FILE_LINK;
  disableLoadBtn = true;
  DOWNLOAD_TEMPLATE = MEDICAL_ORDER_CONSTANTS.DOWNLOAD_TEMPLATE;
  CLEAR_INFORMATION = MEDICAL_ORDER_CONSTANTS.CLEAR_INFORMATION;

  mounted() {
    this.resetFields();
  }

  confirmDialog(isLoad: boolean) {
    if (isLoad) {
      this.modalTitleLoadOrders = MEDICAL_ORDER_CONSTANTS.LOAD.TITLE;
      this.modalTextLoadOrders = MEDICAL_ORDER_CONSTANTS.LOAD.MESSAGE;
    } else {
      this.modalTitleLoadOrders = FORM_MESSAGES.CANCEL_MODAL.TITLE;
      this.modalTextLoadOrders = FORM_MESSAGES.CANCEL_MODAL.MESSAGE;
    }
    this.modalDialogLoadOrders = true;
  }

  async handleModalAccept() {
    this.modalDialogLoadOrders = false;

    if (
      this.modalTitleLoadOrders === FORM_MESSAGES.CANCEL_MODAL.TITLE &&
      !this.isOnModal
    ) {
      this.$router.go(-1);
    } else if (
      this.modalTitleLoadOrders == MEDICAL_ORDER_CONSTANTS.CLEAR.TITLE
    ) {
      this.resetFields();
    } else if (
      this.isOnModal &&
      this.modalTitleLoadOrders === FORM_MESSAGES.CANCEL_MODAL.TITLE
    ) {
      this.resetFields();
      this.$emit(CLOSE_MASIVE_ORDER_MODAL);
    } else {
      await this.loadData();
    }
  }

  handleModalCancel() {
    this.modalDialogLoadOrders = false;
  }

  getFileUploaded(file: File) {
    this.medicalOrdersFile = file;
    if (file) {
      this.disableLoadBtn = false;
      this.errorsLoadOrders = [];
      this.rowsError = 0;
      this.rowsOk = 0;
    } else {
      this.disableLoadBtn = true;
    }
  }

  async loadData() {
    try {
      this.loadingData = true;
      this.disableLoadBtn = true;
      this.errorsLoadOrders = [];
      const result = await this.readFileAsync(this.medicalOrdersFile);

      if (!result) {
        Snackbar.popInfo(MEDICAL_ORDER_CONSTANTS.LOAD_FILE_MESSAGE.NO_DATA);
        this.loadingData = false;
        return;
      }
      const wb = XLSX.read(result, {
        type: "binary",
        dateNF: "yyyy-mm-dd hh:mm:ss"
      });
      const wsname = wb.SheetNames[0];
      const ws = wb.Sheets[wsname];

      const data = XLSX.utils.sheet_to_json(ws, {
        raw: false,
        blankrows: false
      });

      if (data.length == 0) {
        Snackbar.popInfo(
          MEDICAL_ORDER_CONSTANTS.LOAD_FILE_MESSAGE.NO_DATA_PROCESSING
        );
        return;
      }

      const response = await this.medicalOrderService.createMedicalOrders(
        data as Array<Record<string, any>>
      );

      if (response.code == Http.Ok) {
        Snackbar.popSuccess(response.message);
        this.rowsOk = data.length;
        this.loadFinish = true;
      } else if (response.code == Http.PartialContent && response.data) {
        this.errorsLoadOrders = response.data as LoadOrdersError[];
        this.rowsError = response.data.length;
        this.rowsOk = data.length - this.rowsError;
        this.loadFinish = true;
        Snackbar.popWarning(response.message);
      } else if (response.data) {
        this.errorsLoadOrders = response.data as LoadOrdersError[];
        this.rowsError = response.data.length;
        this.rowsOk = data.length - this.rowsError;
        this.loadFinish = true;
        Snackbar.popError(response.message);
      } else {
        Snackbar.popError(response.message);
      }
      this.loadingData = false;
    } catch (error) {
      this.loadingData = false;
      this.disableLoadBtn = false;
      const errorMessage =
        (error as Error).message === GENERAL_CONSTANTS.FORBIDDEN
          ? `${FORM_MESSAGES.FORBIDDEN_REQUEST}${MEDICAL_ORDER_ACCESS.POST}`
          : MEDICAL_ORDER_CONSTANTS.LOAD_FILE_MESSAGE.ERROR_LOAD_FILE;

      Snackbar.popError(errorMessage);
    }
  }

  readFileAsync(file: File) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();

      reader.onload = () => {
        resolve(reader.result);
      };

      reader.onerror = reject;
      reader.readAsBinaryString(file);
    });
  }

  goToStart(id: string) {
    Utils.scrollToElement(id, this);
  }

  resetFields() {
    this.disableLoadBtn = false;
    this.errorsLoadOrders = [];
    this.rowsError = 0;
    this.rowsOk = 0;
    this.loadFinish = true;
    (this.$refs.file as Vue & {
      reset: () => void;
    }).reset();
  }

  confirmReset() {
    if (this.errorsLoadOrders.length > 0) {
      this.modalTitleLoadOrders = MEDICAL_ORDER_CONSTANTS.CLEAR.TITLE;
      this.modalTextLoadOrders = MEDICAL_ORDER_CONSTANTS.CLEAR.MESSAGE;
      this.modalDialogLoadOrders = true;
    } else {
      this.resetFields();
    }
  }
}
